import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ctr-gridcol" }
const _hoisted_2 = {
  key: 0,
  class: "ctr-col-head"
}
const _hoisted_3 = {
  key: 0,
  class: "dx-icon dx-icon-check",
  style: {"color":"#059669","font-weight":"bold"}
}
const _hoisted_4 = {
  key: 1,
  style: {"color":"#cbd5e1"}
}
const _hoisted_5 = { class: "ctr-actions" }
const _hoisted_6 = {
  key: 0,
  class: "ctr-formcol"
}
const _hoisted_7 = { class: "ctr-form-toolbar" }
const _hoisted_8 = {
  key: 0,
  class: "ctr-form-body"
}
const _hoisted_9 = { class: "ctr-g3" }
const _hoisted_10 = { class: "ff" }
const _hoisted_11 = { class: "ff" }
const _hoisted_12 = { class: "ff" }
const _hoisted_13 = { class: "ff full" }
const _hoisted_14 = { class: "ff" }
const _hoisted_15 = { class: "ctr-g3" }
const _hoisted_16 = { class: "ff" }
const _hoisted_17 = { class: "ff" }
const _hoisted_18 = { class: "ff" }
const _hoisted_19 = { class: "ff" }
const _hoisted_20 = { class: "ctr-g3" }
const _hoisted_21 = { class: "ff" }
const _hoisted_22 = { class: "ff" }
const _hoisted_23 = { class: "ff" }
const _hoisted_24 = { class: "ff" }
const _hoisted_25 = { class: "ctr-form-actions" }
const _hoisted_26 = {
  key: 1,
  class: "ctr-form-empty"
}
const _hoisted_27 = { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["emp-card", { 'ctr-split': _ctx.isStandalone }]),
    key: `emp-${_ctx.employeeId}`
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isStandalone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[36] || (_cache[36] = [
            _createElementVNode("i", { class: "dx-icon dx-icon-toolbox" }, null, -1),
            _createTextVNode(" Contracte", -1)
          ]))]))
        : _createCommentVNode("", true),
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.dsContracteMunca,
        ref: "dataGridRef",
        width: "100%",
        "allow-column-reordering": true,
        "allow-column-resizing": true,
        "column-auto-width": false,
        "column-resizing-mode": "widget",
        "show-borders": true,
        "key-expr": "Id",
        "show-column-lines": false,
        "show-row-lines": true,
        "row-alternation-enabled": true,
        "hover-state-enabled": true,
        class: "ctr-grid",
        onRowDblClick: _ctx.onRowDblClick,
        onSelectionChanged: _ctx.onContractSelected
      }, {
        stareTpl: _withCtx(({ data }) => [
          _createElementVNode("span", {
            class: _normalizeClass(["ctr-chip", _ctx.stareClass(data.value)])
          }, _toDisplayString(_ctx.stareLabel(data.value)), 3)
        ]),
        revisalTpl: _withCtx(({ data }) => [
          (data.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_3))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "—"))
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxStateStoring, {
            enabled: !_ctx.isStandalone,
            type: "localStorage",
            "storage-key": "grid-contracte-munca-state"
          }, null, 8, ["enabled"]),
          _createVNode(_component_DxSelection, { mode: "single" }),
          _createVNode(_component_DxFilterRow, { visible: false }),
          _createVNode(_component_DxPaging, {
            "page-size": 10,
            "page-index": 0
          }),
          _createVNode(_component_DxLoadPanel, {
            enabled: true,
            "indicator-src": 'reload6.gif'
          }),
          _createVNode(_component_DxSorting, { mode: "multiple" }),
          _createVNode(_component_DxScrolling, {
            mode: "virtual",
            "column-rendering-mode": "virtual",
            "show-scrollbar": 'always'
          }),
          _createVNode(_component_DxColumnFixing, { enabled: true }),
          _createVNode(_component_DxColumnChooser, {
            enabled: true,
            mode: "select"
          }),
          _createVNode(_component_DxEditing, {
            "allow-updating": !_ctx.isStandalone,
            mode: "popup"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxPopup, {
                closeOnOutsideClick: false,
                showCloseButton: false,
                width: 700,
                height: 450,
                "show-title": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                  _createVNode(_component_DxToolbarItem, {
                    toolbar: "bottom",
                    widget: "dxButton",
                    location: "after",
                    options: _ctx.saveButtonOptions
                  }, null, 8, ["options"]),
                  _createVNode(_component_DxToolbarItem, {
                    toolbar: "bottom",
                    widget: "dxButton",
                    location: "after",
                    options: _ctx.dangerButtonOptions
                  }, null, 8, ["options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["allow-updating"]),
          _createVNode(_component_DxColumn, {
            "data-field": "NumarContract",
            width: "120",
            caption: "Nr. contract"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "StareCurenta",
            width: _ctx.isStandalone ? undefined : 160,
            caption: "Stare",
            "cell-template": "stareTpl"
          }, null, 8, ["width"]),
          _createVNode(_component_DxColumn, {
            "data-field": "TransferInRevisal",
            width: "120",
            caption: "Revisal",
            "cell-template": "revisalTpl",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "CorId",
            width: "220",
            caption: "COR Cod",
            visible: !_ctx.isStandalone
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxLookup, {
                "data-source": _ctx.dsCor,
                "value-expr": "Id",
                "display-expr": _ctx.corDisplayExpr,
                "search-enabled": true
              }, null, 8, ["data-source", "display-expr"])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "CorVersiune",
            width: "110",
            caption: "COR Versiune",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "DataConsemnare",
            width: "130",
            format: "dd.MM.yyyy",
            "data-type": "date",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "DataIncepereActivitate",
            width: _ctx.isStandalone ? undefined : 140,
            caption: "Data",
            format: "dd.MM.yyyy",
            "data-type": "date"
          }, null, 8, ["width"]),
          _createVNode(_component_DxColumn, {
            "data-field": "DataIncheiereContract",
            width: "140",
            format: "dd.MM.yyyy",
            "data-type": "date",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "SalariuBrut",
            width: "100",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "SporTipNume",
            width: "100",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "TimpMuncaNorma",
            width: "100",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "TimpMuncaRepartizare",
            width: "100",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "TimpMuncaDurata",
            width: "100",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "TipContract",
            width: "100",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "TipNorma",
            width: "100",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "Radiat",
            width: "100",
            visible: !_ctx.isStandalone
          }, null, 8, ["visible"]),
          _createVNode(_component_DxColumn, {
            "data-field": "DataCreare",
            width: "100",
            visible: false,
            format: "dd.MM.yyyy",
            "data-type": "date"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DateContractVechi",
            width: "140",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Detalii",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "AngajatorSursaCui",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "AngajatorSursaDenumire",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataImport",
            width: "100",
            visible: false,
            format: "dd.MM.yyyy",
            "data-type": "date"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TipMutare",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ExceptieDataSfarsit",
            width: "100",
            visible: false,
            format: "dd.MM.yyyy",
            "data-type": "date"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "NumereContractVechi",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TimpMuncaIntervalTimp",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataReactivare",
            width: "100",
            visible: false,
            format: "dd.MM.yyyy",
            "data-type": "date"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "EchipamentIndividualProtectie",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "EchipamentIndividualLucru",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "MaterialeIgienicoSanitare",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "AlimentatieProtectie",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "AlteDrepturiObligatiiSsm",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "NumarContractColectivMunca",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataIncheiereContractColectiv",
            width: "100",
            visible: false,
            format: "dd.MM.yyyy",
            "data-type": "date"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "SeriePermisMunca",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "NumarPermisMunca",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataPermisMunca",
            width: "100",
            visible: false,
            format: "dd.MM.yyyy",
            "data-type": "date"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "LocatiaDesfasurariiActivitatii",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "NrLuniActivitate",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ConcediuOdihnaSuplimentar",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataPlataSalariu",
            width: "100",
            visible: false,
            format: "dd.MM.yyyy",
            "data-type": "date"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PerioadaProba",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TipPreaviz",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PerioadaPreaviz",
            width: "100",
            visible: false
          }),
          _createVNode(_component_DxToolbar, null, {
            default: _withCtx(() => [
              (_ctx.$route.name !== 'Contracte')
                ? (_openBlock(), _createBlock(_component_DxItem, {
                    key: 0,
                    location: "before"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "continue-application",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToContracts && _ctx.goToContracts(...args)))
                      }, [...(_cache[37] || (_cache[37] = [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", { class: "folder" }, [
                            _createElementVNode("div", { class: "top" }, [
                              _createElementVNode("svg", { viewBox: "0 0 24 27" }, [
                                _createElementVNode("path", { d: "M0 0h24v27H0z" })
                              ])
                            ]),
                            _createElementVNode("div", { class: "paper" })
                          ]),
                          _createElementVNode("div", { class: "pencil" })
                        ], -1),
                        _createTextVNode(" Vezi pagina de contracte ", -1)
                      ]))])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$route.name == 'Contracte')
                ? (_openBlock(), _createBlock(_component_DxItem, {
                    key: 1,
                    location: "before"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxButton, {
                        text: "Înapoi",
                        icon: "arrowleft",
                        type: "default",
                        class: "back-button",
                        onClick: _ctx.goBack
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.isStandalone)
                ? (_openBlock(), _createBlock(_component_DxItem, {
                    key: 2,
                    location: "before"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_DxButton, {
                          icon: "edit",
                          hint: "Corecție",
                          "styling-mode": "outlined",
                          class: "ctr-act",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubAction('corectie')))
                        }),
                        _createVNode(_component_DxButton, {
                          icon: "clock",
                          hint: "Suspendare",
                          "styling-mode": "outlined",
                          class: "ctr-act",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubAction('suspendare')))
                        }),
                        _createVNode(_component_DxButton, {
                          icon: "export",
                          hint: "Detașare",
                          "styling-mode": "outlined",
                          class: "ctr-act",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubAction('detasare')))
                        }),
                        _createVNode(_component_DxButton, {
                          icon: "home",
                          hint: "Schimbare loc muncă",
                          "styling-mode": "outlined",
                          class: "ctr-act",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubAction('schimbLocMunca')))
                        }),
                        _createVNode(_component_DxButton, {
                          icon: "close",
                          hint: "Încetare/Reactivare",
                          "styling-mode": "outlined",
                          class: "ctr-act",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSubAction('incetareReactivare')))
                        }),
                        _createVNode(_component_DxButton, {
                          icon: "bulletlist",
                          hint: "Istoric",
                          "styling-mode": "outlined",
                          class: "ctr-act",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSubAction('istoric')))
                        }),
                        _createVNode(_component_DxButton, {
                          icon: "doc",
                          hint: "L153",
                          "styling-mode": "outlined",
                          class: "ctr-act",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSubAction('l153')))
                        })
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.isStandalone)
                ? (_openBlock(), _createBlock(_component_DxItem, {
                    key: 3,
                    location: "after"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxButton, {
                        icon: "add",
                        text: "Adaugă contract",
                        type: "success",
                        "styling-mode": "contained",
                        onClick: _ctx.onAddClick
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data-source", "onRowDblClick", "onSelectionChanged"])
    ]),
    (_ctx.isStandalone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DxButton, {
              icon: "edit",
              text: "Corecție",
              "styling-mode": "outlined",
              class: "ctr-act",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSubAction('corectie')))
            }),
            _createVNode(_component_DxButton, {
              icon: "clock",
              text: "Suspendare",
              "styling-mode": "outlined",
              class: "ctr-act",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSubAction('suspendare')))
            }),
            _createVNode(_component_DxButton, {
              icon: "export",
              text: "Detașare",
              "styling-mode": "outlined",
              class: "ctr-act",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSubAction('detasare')))
            }),
            _createVNode(_component_DxButton, {
              icon: "home",
              text: "Schimb. loc muncă",
              "styling-mode": "outlined",
              class: "ctr-act",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onSubAction('schimbLocMunca')))
            }),
            _createVNode(_component_DxButton, {
              icon: "close",
              text: "Încetare/Reactivare",
              "styling-mode": "outlined",
              class: "ctr-act",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSubAction('incetareReactivare')))
            }),
            _createVNode(_component_DxButton, {
              icon: "bulletlist",
              text: "Istoric",
              "styling-mode": "outlined",
              class: "ctr-act",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSubAction('istoric')))
            }),
            _createVNode(_component_DxButton, {
              icon: "doc",
              text: "L153",
              "styling-mode": "outlined",
              class: "ctr-act",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSubAction('l153')))
            }),
            _createVNode(_component_DxButton, {
              icon: "add",
              text: "Adaugă contract",
              type: "success",
              "styling-mode": "contained",
              class: "ctr-add-btn",
              onClick: _ctx.addNouContract
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["ctr-form-head", { 'is-new': _ctx.editIsNew }])
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["dx-icon", _ctx.editIsNew ? 'dx-icon-add' : 'dx-icon-edit'])
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(_ctx.editIsNew ? 'Contract nou' : (_ctx.editForm.NumarContract ? ('Contract ' + _ctx.editForm.NumarContract) : 'Selectează un contract')), 1),
            (!_ctx.editIsNew && _ctx.editForm.StareCurenta)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["ctr-chip", _ctx.stareClass(_ctx.editForm.StareCurenta)]),
                  style: {"margin-left":"auto"}
                }, _toDisplayString(_ctx.stareLabel(_ctx.editForm.StareCurenta)), 3))
              : _createCommentVNode("", true)
          ], 2),
          (_ctx.editForm.Id || _ctx.editIsNew)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[50] || (_cache[50] = _createElementVNode("div", { class: "ctr-seclbl" }, "Date contract", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", null, "Număr contract", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: _ctx.editForm.NumarContract,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editForm.NumarContract) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[39] || (_cache[39] = _createElementVNode("label", null, "Tip contract", -1)),
                    _createVNode(_component_DxSelectBox, {
                      "data-source": _ctx.dsTipContract,
                      "value-expr": "Cod",
                      "display-expr": "Nume",
                      value: _ctx.editForm.TipContract,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editForm.TipContract) = $event)),
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["data-source", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", null, "Tip normă", -1)),
                    _createVNode(_component_DxSelectBox, {
                      "data-source": _ctx.dsTipNorma,
                      "value-expr": "Cod",
                      "display-expr": "Nume",
                      value: _ctx.editForm.TipNorma,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editForm.TipNorma) = $event)),
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["data-source", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[41] || (_cache[41] = _createElementVNode("label", null, "Funcție (COR)", -1)),
                    _createVNode(_component_DxSelectBox, {
                      "data-source": _ctx.dsCor,
                      "value-expr": "Id",
                      "display-expr": _ctx.corDisplayExpr,
                      value: _ctx.editForm.CorId,
                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editForm.CorId) = $event)),
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["data-source", "display-expr", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", null, "Transfer în Revisal", -1)),
                    _createVNode(_component_DxCheckBox, {
                      value: _ctx.editForm.TransferInRevisal,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editForm.TransferInRevisal) = $event))
                    }, null, 8, ["value"])
                  ])
                ]),
                _cache[51] || (_cache[51] = _createElementVNode("hr", { class: "ctr-fline" }, null, -1)),
                _cache[52] || (_cache[52] = _createElementVNode("div", { class: "ctr-seclbl" }, "Perioade", -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[43] || (_cache[43] = _createElementVNode("label", null, "Consemnare", -1)),
                    _createVNode(_component_DxDateBox, {
                      value: _ctx.editForm.DataConsemnare,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editForm.DataConsemnare) = $event)),
                      type: "date",
                      "display-format": "dd.MM.yyyy"
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", null, "Data CIM", -1)),
                    _createVNode(_component_DxDateBox, {
                      value: _ctx.editForm.DataCim,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editForm.DataCim) = $event)),
                      type: "date",
                      "display-format": "dd.MM.yyyy"
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[45] || (_cache[45] = _createElementVNode("label", null, "Început activitate", -1)),
                    _createVNode(_component_DxDateBox, {
                      value: _ctx.editForm.DataIncepereActivitate,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editForm.DataIncepereActivitate) = $event)),
                      type: "date",
                      "display-format": "dd.MM.yyyy"
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[46] || (_cache[46] = _createElementVNode("label", null, "Încheiere contract", -1)),
                    _createVNode(_component_DxDateBox, {
                      value: _ctx.editForm.DataIncheiereContract,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editForm.DataIncheiereContract) = $event)),
                      type: "date",
                      "display-format": "dd.MM.yyyy"
                    }, null, 8, ["value"])
                  ])
                ]),
                _cache[53] || (_cache[53] = _createElementVNode("hr", { class: "ctr-fline" }, null, -1)),
                _cache[54] || (_cache[54] = _createElementVNode("div", { class: "ctr-seclbl" }, "Normă & salariu", -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", null, "Normă (ore)", -1)),
                    _createVNode(_component_DxSelectBox, {
                      "data-source": _ctx.dsTimpMuncaNorma,
                      "value-expr": "Cod",
                      "display-expr": "Nume",
                      value: _ctx.editForm.TimpMuncaNorma,
                      "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editForm.TimpMuncaNorma) = $event)),
                      "search-enabled": true,
                      "show-clear-button": true
                    }, null, 8, ["data-source", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[48] || (_cache[48] = _createElementVNode("label", null, "Salariu brut", -1)),
                    _createVNode(_component_DxNumberBox, {
                      value: _ctx.editForm.SalariuBrut,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.editForm.SalariuBrut) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[49] || (_cache[49] = _createElementVNode("label", null, "Spor", -1)),
                    _createVNode(_component_DxSelectBox, {
                      "data-source": _ctx.sporNames,
                      value: _ctx.editForm.SporTipNume,
                      "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.editForm.SporTipNume) = $event)),
                      "search-enabled": true,
                      "accept-custom-value": true,
                      "show-clear-button": true,
                      placeholder: "[selectați din listă]"
                    }, null, 8, ["data-source", "value"])
                  ])
                ]),
                _cache[55] || (_cache[55] = _createElementVNode("hr", { class: "ctr-fline" }, null, -1)),
                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "ctr-seclbl" }, "Observații", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_DxTextArea, {
                    value: _ctx.editForm.Detalii,
                    "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.editForm.Detalii) = $event)),
                    height: 70
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_DxButton, {
                    icon: "save",
                    text: "Salvează",
                    type: "success",
                    "styling-mode": "contained",
                    onClick: _ctx.salveazaContractForm
                  }, null, 8, ["onClick"]),
                  (_ctx.editIsNew)
                    ? (_openBlock(), _createBlock(_component_DxButton, {
                        key: 0,
                        icon: "close",
                        text: "Renunță",
                        type: "normal",
                        "styling-mode": "outlined",
                        onClick: _ctx.anuleazaContractNou
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[57] || (_cache[57] = [
                _createElementVNode("i", { class: "dx-icon dx-icon-doc" }, null, -1),
                _createElementVNode("p", null, [
                  _createTextVNode("Selectează un contract din stânga pentru editare"),
                  _createElementVNode("br"),
                  _createTextVNode("sau apasă "),
                  _createElementVNode("b", null, "Adaugă contract"),
                  _createTextVNode(".")
                ], -1)
              ]))]))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.addPopupVisible,
      "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.addPopupVisible) = $event)),
      "show-title": true,
      height: 450,
      width: 700
    }, {
      title: _withCtx(() => [...(_cache[58] || (_cache[58] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "form-data": _ctx.formData,
          "label-alignment": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "NumarContract",
              label: { text: 'Număr contract' },
              "is-required": true
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataConsemnare",
              "editor-type": "dxDateBox",
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Data consemnare' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataCim",
              "editor-type": "dxDateBox",
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Data CIM' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataIncepereActivitate",
              "editor-type": "dxDateBox",
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Început activitate' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataIncheiereContract",
              "editor-type": "dxDateBox",
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Încheiere contract' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "CorId",
              "editor-type": "dxSelectBox",
              label: { text: 'Funcție (COR)' },
              "editor-options": { dataSource: _ctx.dsCor, valueExpr: 'Id', displayExpr: _ctx.corDisplayExpr, searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "TipContract",
              "editor-type": "dxSelectBox",
              label: { text: 'Tip contract' },
              "editor-options": { dataSource: _ctx.dsTipContract, valueExpr: 'Cod', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "TipNorma",
              "editor-type": "dxSelectBox",
              label: { text: 'Tip normă' },
              "editor-options": { dataSource: _ctx.dsTipNorma, valueExpr: 'Cod', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "TimpMuncaNorma",
              label: { text: 'Normă (ore)' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "SalariuBrut",
              "editor-type": "dxNumberBox",
              label: { text: 'Salariu brut' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "SporTipNume",
              label: { text: 'Spor' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "TransferInRevisal",
              "editor-type": "dxCheckBox",
              label: { text: 'Transfer în Revisal' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Detalii",
              label: { text: 'Detalii' },
              "col-span": 2
            })
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.addButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.closeButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.istoricPopupVisible,
      "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.istoricPopupVisible) = $event)),
      "show-title": true,
      title: "Istoric contracte",
      height: 560,
      width: 900,
      "drag-enabled": true,
      "defer-rendering": false
    }, {
      title: _withCtx(() => [...(_cache[59] || (_cache[59] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Istoric contracte ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxDataGrid, {
          "data-source": _ctx.dsIstoric,
          "show-borders": true,
          "column-auto-width": true,
          height: "100%",
          "no-data-text": 'Nu există versiuni istorice.'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSorting, { mode: "multiple" }),
            _createVNode(_component_DxColumn, {
              "data-field": "NumarContract",
              caption: "Nr. contract",
              width: "120"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "StareCurenta",
              caption: "Stare",
              width: "150"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "TipMutare",
              caption: "Tip acțiune",
              width: "130"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "DataConsemnare",
              caption: "Consemnare",
              "data-type": "date",
              format: "dd.MM.yyyy",
              width: "120"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "DataIncepereActivitate",
              caption: "Început",
              "data-type": "date",
              format: "dd.MM.yyyy",
              width: "110"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "DataIncheiereContract",
              caption: "Încheiere",
              "data-type": "date",
              format: "dd.MM.yyyy",
              width: "110"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "SalariuBrut",
              caption: "Salariu brut",
              width: "110"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "TipContract",
              caption: "Tip contract",
              width: "120"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "DataCreare",
              caption: "Creat la",
              "data-type": "date",
              format: "dd.MM.yyyy HH:mm",
              width: "140",
              "sort-index": 0,
              "sort-order": "desc"
            })
          ]),
          _: 1
        }, 8, ["data-source"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.istoricCloseButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.suspendarePopupVisible,
      "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.suspendarePopupVisible) = $event)),
      "show-title": true,
      height: 420,
      width: 640,
      "drag-enabled": true
    }, {
      title: _withCtx(() => [...(_cache[60] || (_cache[60] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Suspendare contract ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "form-data": _ctx.suspendareForm,
          "label-alignment": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataInceput",
              "editor-type": "dxDateBox",
              "is-required": true,
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Data început' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataSfarsit",
              "editor-type": "dxDateBox",
              "is-required": true,
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Data sfârșit' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "TemeiLegal",
              "col-span": 2,
              "editor-type": "dxSelectBox",
              label: { text: 'Temei legal (Revisal)' },
              "editor-options": { dataSource: _ctx.dsTemeiSuspendare, valueExpr: 'CodRevisal', displayExpr: 'name', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Explicatie",
              "editor-type": "dxTextArea",
              "col-span": 2,
              label: { text: 'Alte detalii' },
              "editor-options": { height: 70 }
            })
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.suspendareSaveButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.suspendareCloseButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.incetarePopupVisible,
      "onUpdate:visible": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.incetarePopupVisible) = $event)),
      "show-title": true,
      height: 470,
      width: 660,
      "drag-enabled": true
    }, {
      title: _withCtx(() => [...(_cache[61] || (_cache[61] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Încetare contract ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "form-data": _ctx.incetareForm,
          "label-alignment": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "TipPlecareId",
              "editor-type": "dxSelectBox",
              "col-span": 2,
              "is-required": true,
              label: { text: 'Tip plecare' },
              "editor-options": { dataSource: _ctx.dsTipuriPlecare, valueExpr: 'Id', displayExpr: 'name', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataPlecarii",
              "editor-type": "dxDateBox",
              "is-required": true,
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Ultima zi lucrată' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataIncetareContract",
              "editor-type": "dxDateBox",
              "is-required": true,
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Data încetare CIM' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DecizieNr",
              "col-span": 2,
              label: { text: 'Decizie Nr' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Observatii",
              "editor-type": "dxTextArea",
              "col-span": 2,
              label: { text: 'Observații' },
              "editor-options": { height: 60 }
            })
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.incetareSaveButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.incetareCloseButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.reactivarePopupVisible,
      "onUpdate:visible": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.reactivarePopupVisible) = $event)),
      "show-title": true,
      height: 380,
      width: 620,
      "drag-enabled": true
    }, {
      title: _withCtx(() => [...(_cache[62] || (_cache[62] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Reactivare contract ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "form-data": _ctx.reactivareForm,
          "label-alignment": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataReactivare",
              "editor-type": "dxDateBox",
              "is-required": true,
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Data reactivare' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "TemeiLegal",
              "editor-type": "dxSelectBox",
              label: { text: 'Temei legal (Revisal)' },
              "editor-options": { dataSource: _ctx.dsTemeiReactivare, valueExpr: 'CodRevisal', displayExpr: 'name', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Explicatie",
              "editor-type": "dxTextArea",
              "col-span": 2,
              label: { text: 'Alte detalii' },
              "editor-options": { height: 60 }
            })
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.reactivareSaveButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.reactivareCloseButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.detasarePopupVisible,
      "onUpdate:visible": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.detasarePopupVisible) = $event)),
      "show-title": true,
      height: 470,
      width: 660,
      "drag-enabled": true
    }, {
      title: _withCtx(() => [...(_cache[63] || (_cache[63] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Detașare contract ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "form-data": _ctx.detasareForm,
          "label-alignment": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "AngajatorNume",
              "col-span": 2,
              "is-required": true,
              label: { text: 'Denumire angajator destinație' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "AngajatorCui",
              "is-required": true,
              label: { text: 'CUI angajator destinație' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Tara",
              label: { text: 'Țara' },
              "editor-options": { placeholder: 'România' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataInceput",
              "editor-type": "dxDateBox",
              "is-required": true,
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Data început' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataSfarsit",
              "editor-type": "dxDateBox",
              "is-required": true,
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Data sfârșit' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Explicatie",
              "editor-type": "dxTextArea",
              "col-span": 2,
              label: { text: 'Observații' },
              "editor-options": { height: 60 }
            })
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.detasareSaveButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.detasareCloseButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.schimbLocPopupVisible,
      "onUpdate:visible": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.schimbLocPopupVisible) = $event)),
      "show-title": true,
      height: 440,
      width: 660,
      "drag-enabled": true
    }, {
      title: _withCtx(() => [...(_cache[64] || (_cache[64] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Schimbare loc muncă ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "form-data": _ctx.schimbLocForm,
          "label-alignment": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "StructuraDestinatieId",
              "editor-type": "dxSelectBox",
              "col-span": 2,
              "is-required": true,
              label: { text: 'Punct de lucru destinație' },
              "editor-options": { dataSource: _ctx.dsStructuraDest, valueExpr: 'Id', displayExpr: _ctx.structDisplayExpr, searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "ActAditional",
              "is-required": true,
              label: { text: 'Act adițional' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "ActAditionalData",
              "editor-type": "dxDateBox",
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Data act adițional' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "DataProduceEfecte",
              "editor-type": "dxDateBox",
              "is-required": true,
              "editor-options": { displayFormat: 'dd.MM.yyyy', type: 'date' },
              label: { text: 'Produce efecte cu' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Observatii",
              "editor-type": "dxTextArea",
              "col-span": 2,
              label: { text: 'Observații' },
              "editor-options": { height: 60 }
            })
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.schimbLocSaveButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.schimbLocCloseButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.l153PopupVisible,
      "onUpdate:visible": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.l153PopupVisible) = $event)),
      "show-title": true,
      height: 600,
      width: 820,
      "drag-enabled": true
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, " Încadrare L153 (Legea 153) — " + _toDisplayString(_ctx.l153AngajatNume), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "form-data": _ctx.l153Form,
          "label-alignment": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "TipRaportId",
              "editor-type": "dxSelectBox",
              label: { text: 'Tip raport' },
              "editor-options": { dataSource: _ctx.l153Nom.TipRaport, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "FunctieId",
              "editor-type": "dxSelectBox",
              label: { text: 'Funcție' },
              "editor-options": { dataSource: _ctx.l153Nom.Functii, valueExpr: 'ID', displayExpr: _ctx.l153FunctieDisplay, searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "AltaFunctie",
              label: { text: 'Altă funcție' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "ExplicatiFunctie",
              label: { text: 'Explicație funcție' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "StudiiId",
              "editor-type": "dxSelectBox",
              label: { text: 'Studii' },
              "editor-options": { dataSource: _ctx.l153Nom.Studii, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "GradId",
              "editor-type": "dxSelectBox",
              label: { text: 'Grad' },
              "editor-options": { dataSource: _ctx.l153Nom.Grad, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Gradatie",
              label: { text: 'Gradație' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Vechime",
              label: { text: 'Vechime' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Norma",
              "editor-type": "dxSelectBox",
              label: { text: 'Normă' },
              "editor-options": { dataSource: _ctx.l153Norme, valueExpr: 'Cod', displayExpr: 'Nume', showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "SpecialitateFunctieId",
              "editor-type": "dxSelectBox",
              label: { text: 'Specialitate funcție' },
              "editor-options": { dataSource: _ctx.l153Nom.SpecialitateFunctie, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "StructuraId",
              "editor-type": "dxSelectBox",
              label: { text: 'Structură aprobată' },
              "editor-options": { dataSource: _ctx.l153Nom.Structura, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "StructuraGardaId",
              "editor-type": "dxSelectBox",
              label: { text: 'Specialitate structură gardă' },
              "editor-options": { dataSource: _ctx.l153Nom.StructuraGarda, valueExpr: 'ID', displayExpr: 'Nume', searchEnabled: true, showClearButton: true }
            }, null, 8, ["editor-options"]),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "SalariuBaza",
              label: { text: 'Salariu bază' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "SalariuBrut",
              label: { text: 'Salariu brut' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "NormeSal",
              label: { text: 'Norme salariale' }
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Valuta",
              label: { text: 'Valută' }
            })
          ]),
          _: 1
        }, 8, ["form-data"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.l153SaveButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.l153CloseButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 2))
}